import { gql } from "@apollo/client";

const NOTIFY_PARTNER = gql`
  mutation cnrNotification($id: String!) {
    cnrNotification(id: $id)
  }
`;

export default NOTIFY_PARTNER;